import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageCustomers from "./manageUsers";
import ManageCustomerDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";
import ManageCustomerSupport from "./manageCustomerSupport";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import ManageRevenue from "./manageRevenue";
import ManageSubscriptions from "./manageSubscriptions";
import ManageSubscriptionDetail from "./manageSubscriptions/view";
import Settings from "./settings";
import ManageBookings from "./manageBookings";
import ManageCategories from "./manageCategories";
import ManageSubCategories from "./manageCategories/subCategories";
import GeoFencing from "./geoFencing";
import AddGeoFencing from "./geoFencing/addGeoFencing";
import Edituser from "./manageUsers/edit";
import ManageReviews from "./manageReviews";
import AddSubscription from "./manageSubscriptions/add";
import ViewBookings from "./manageBookings/view";
import LoyaltyPoints from "./loyaltypoints";
import ManageServiceProviders from "./manageServiceProviders";
import EditServiceProvider from "./manageServiceProviders/edit";
import ViewServiceProviders from "./manageServiceProviders/view";
import AddServiceProvider from "./manageServiceProviders/add";
import ManageReports from "./manageReports";
export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageCustomers,
  ManageCustomerDetail,
  ManageCategories,
  ManageSubCategories,
  ManageRevenue,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ManageCustomerSupport,
  ManageNotifications,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSubscriptions,
  AddSubscription,
  ManageSubscriptionDetail,
  GeoFencing,
  AddGeoFencing,
  Settings,
  ManageBookings,
  Edituser,
  ViewBookings,
  LoyaltyPoints,
  ManageReviews,
  ManageServiceProviders,
  EditServiceProvider ,
  ViewServiceProviders,
  AddServiceProvider,
  ManageReports

};
